import fileInfo from 'scoreboard/components/files/file-info'
import i18n from 'scoreboard/components/i18n'
import _ from 'lodash'

/**
 * Returns a validator function that validates a file's extension.
 *
 * @param {Array} accept file types that are allowed ('image', 'document', etc)
 * 						 see fileInfo.extensions for full list
 */
function fileExtensionValidatorFactory (accept) {
	return fileName => {
		// when nothing is specified for 'accept', that means there
		// are no restrictions on the type of the file and any extension is fine
		if (_.isEmpty(accept)) {
			return null
		}

		let extension = _.lowerCase(fileInfo.extension(fileName))
		// an array of all valid file extensions
		let validExtensions = _(accept)
			.map(type => fileInfo.extensions[type])
			.flatten()
			.value()

		let valid = _.includes(validExtensions, extension)
		return valid
			? null
			: i18n.get('documents.invalidExtension', _.join(validExtensions, ', '))
	}
}

export default fileExtensionValidatorFactory

fileExtensionValidatorFactory.__filename__ = 'components/validators/file-extension-validator-factory.js'
